import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'material-react-toastify/dist/ReactToastify.css';
import './index.css';
import createCache from '@emotion/cache';
import { ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'material-react-toastify';
import { RecoilRoot } from 'recoil';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { theme } from './utils/Theme';
import { PopupProvider } from './components/Popup/PopupProvider';
import './i18n';

export const muiCache = createCache({
  key: 'mui',
  prepend: true,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <CacheProvider value={muiCache}>
    <RecoilRoot>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <HelmetProvider>
            <PopupProvider>
              <App />
            </PopupProvider>
            <ToastContainer
              position='top-center'
              autoClose={6000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              draggable
              pauseOnHover
            />
          </HelmetProvider>
        </ThemeProvider>
      </BrowserRouter>
    </RecoilRoot>
  </CacheProvider>,
);
